<template>
  <div class="main-box">
    <span v-show="false">{{getPropItems}}</span>
    <div class="container-head fx" :style="{padding:(selectWidth == 46 ? '15px 30px' : '15px 8px')}">
      <div class="container-head-left">
        <span class="unlf">
          <img src="~@/assets/gbIcon/comtc_icon.png" alt="" class="imgIcon">
          <span @click="titleHandle">{{propItems.companyName}}</span>
        </span>
        <span class="tags" v-if="propItems.regStatus">{{propItems.regStatus}}</span>
        <div :class="['bg',{'unstar':!propItems.star}]" @click.stop="handleStarB"></div>
        <!-- 解锁时间 -->
        <div class="unlock-time">
          解锁时间：{{propItems.createTime}}
        </div>
      </div>
      <div class="container-head-right recycle mr-16" v-if="type !== 3 && propItems.infoList.some(e=>e.isTurnClue==0|| e.isTurnClue==null)" @click="removeCompanyToTrash">
        <i class="iconfont icon-huishouzhan"></i>
        回收站
      </div>
      <div class="container-head-right zk" @click="clickChange(propItems)" v-show="propItems.infoList&&propItems.infoList.length>0">
        {{propItems.collapse?'收起':'展开'}}<i :class="propItems.collapse?'el-icon-arrow-up':'el-icon-arrow-down'" />
      </div>
    </div>
    <el-table row-key="cid" :data="propItems.infoList" :header-cell-style="{background: '#F7F7FA'}" class="table-content"
      :class="propItems.collapse&&propItems.infoList&&propItems.infoList.length>0?'height-anima-open':'height-anima-close'" :cell-class-name="addClass">
      <el-table-column :width="selectWidth">
        <template slot="header" slot-scope="scope">
          <el-checkbox v-model="checkAll" @change="changeAll()"></el-checkbox>
        </template>
        <template slot-scope="scope">
          <!-- <el-checkbox v-model="scope.row.checked" @change="changeOne(scope.row,propItems.estiblishTime)" :disabled="selectEnable(scope.row)"></el-checkbox> -->
          <el-checkbox v-model="scope.row.checked" @change="changeOne(scope.row,propItems.estiblishTime)"></el-checkbox>
        </template>
      </el-table-column>
      <!-- <el-table-column label="解锁时间" prop="createTime" align="center"></el-table-column> -->
      <!-- <el-table-column label="解锁方式" prop="unlockType" align="center">
        <template slot-scope="scope">{{ scope.row.unlockType == 1 ? '手动解锁' : '自动解锁' }}</template>
      </el-table-column> -->
      <el-table-column label="联系方式来源">
        <template slot-scope="scope">
          <span v-if="scope.row.sources&&scope.row.sources.length === 1">
            <a class="underline fontSize hover" rel="noopener noreferrer" v-if="scope.row.sources[0].sourceHref" :href="scope.row.sources[0].sourceHref" target="about"
              @click.stop="">{{scope.row.sources[0].source}}</a>
            <span v-else class="fontSize">{{scope.row.sources[0].source}}</span>
          </span>

          <span v-show="scope.row.sources&&scope.row.sources.length>1">{{scope.row.sources[0].source}}...</span>
          <el-popover placement="bottom" width="200" trigger="click" popper-class="popoverTable">
            <div v-for="(s,index) in scope.row.sources" :key="index" v-if="scope.row.sources&&scope.row.sources.length">
              <a class="underline source hover" rel="noopener noreferrer" v-if="s.sourceHref" :href="s.sourceHref" :title="s.source" target="about" @click.stop=""><img :src="quan" alt=""
                  srcset="">{{s.source}}</a>
              <span v-else @click.stop="" :title="s.source" class="nohands source"><img :src="quan" alt="" srcset="">{{s.source}}</span>
            </div>
            <el-link slot="reference" v-show="scope.row.sources&&scope.row.sources.length>1" type="primary">({{scope.row.sources&&scope.row.sources.length}})</el-link>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="联系人" prop="contactName" :width="contactNameWidthFlag?'72':'78'">
        <template slot-scope="scope">
          {{scope.row.contactName||'-'}}
        </template>
      </el-table-column>
      <el-table-column label="联系方式" prop="content">
        <template slot-scope="scope">
          <!-- 1:手机，2:固话，3:邮箱，4:微信，5:QQ，6:传真 -->
          <div :class="lableLine(scope.row.label) ?'line-through':''">
            {{ scope.row.content }}<i class="el-icon-document-copy copy-icon" @click="copyName(scope.row)">复制</i>
          </div>
          <!-- <img class="ml-10" style="cursor: pointer;" @click="clickCall(scope.row)" v-if="(scope.row.type == 1 || scope.row.type == 2)&&!$route.query.hide" src="~@/assets/call/call-phone.svg" alt=""> -->
        </template>
      </el-table-column>
      <el-table-column label="备注" prop="content" :width="contactNameWidthFlag?'230':'390'">
        <template slot-scope="{row,$index}">
          <div class="label-content">
            <div class="label">
              <template v-if="!hasLabel(row.label)">
                <el-popover trigger="hover" effect="light" placement="top" popper-class="marksPP">
                  <div class="tag-content-hover">
                    <span :class="['tag', tagColor(row.label, tag)]" v-for="tag in marksTag" :key="tag" @click="choiceTag(tag,row)">
                      {{tag}}
                    </span>
                  </div>
                  <div class="tag-content" slot="reference">
                    <span class="addIcon"></span>
                  </div>
                </el-popover>
              </template>
              <template v-else>
                <el-popover trigger="hover" effect="light" placement="top" popper-class="marksPP">
                  <div class="tag-content-hover">
                    <span :class="['tag', tagColor(row.label, tag)]" v-for="tag in marksTag" :key="tag" @click="choiceTag(tag,row)">
                      {{tag}}
                    </span>
                  </div>
                  <div class="tag-content" slot="reference">
                    <el-tag type="theme" :class="['mTag',tagBgColor[row.label]]" size="medium" closable @close="closeTag(row.sid)">{{row.label}}</el-tag>
                    <!-- <span  :class="['mTag',tagBgColor[row.label]]" v-if="hasLabel(row.label)" closable>{{row.label}}</span> -->
                    <!-- <span class="addIcon" v-else></span> -->
                  </div>
                </el-popover>
              </template>
            </div>
            <!-- 备注显示输入框 -->
            <template v-if="hasLabel(row.remark) && row.focusType == false">
              <div class="remark" @click="remarkFocus(row,$index)">
                <textOverflow effect="light">{{row.remark}}</textOverflow>
              </div>
            </template>
            <template v-else>
              <el-input v-if="row.focusType== true && hasLabel(row.remark)" class="marksInput" v-focus :ref="`remark${row.cid}Input`" :maxlength="30" v-model="row.remarkInput" placeholder="请输入"
                @focus="labelFocus($event, row)" @blur="labelBlur($event, row)"></el-input>
              <el-input v-else class="marksInput" :ref="`remark${row.cid}Input`" :maxlength="30" v-model="row.remarkInput" placeholder="请输入" @focus="labelFocus($event, row)"
                @blur="labelBlur($event, row)"></el-input>
            </template>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="联系方式标签" prop="isFollow" align="center" min-width="100" width="135">
        <template slot-scope="scope">
          <el-tooltip popper-class="contact-tag" v-if="scope.row.numStatus == 5 && scope.row.isKeyContact == 1" class="item" effect="light" placement="top">
            <span class="singleTag bookkeepingAgency">代理记账</span>
            <div class="twoTag" slot="content">
              <span>代理记账</span><span>疑似关键联系人</span>
            </div>
          </el-tooltip>
          <span class="singleTag bookkeepingAgency" v-else-if="scope.row.numStatus == 5">代理记账</span>
          <span class="singleTag suspectedContact" v-else-if="scope.row.isKeyContact == 1">疑似关键联系人</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="跟进状态" prop="isFollow" align="center" :width="contactNameWidthFlag?'86':''">
        <template slot-scope="scope"><span :class="['followStatus',scope.row.isFollow == 1?'haveFollow':'noFollow']">{{ scope.row.isFollow == 1 ? '已跟进' : '未跟进' }}</span></template>
      </el-table-column>
      <el-table-column label="号码状态" prop="state" :width="contactNameWidthFlag?'86':''">
        <template slot-scope="scope"><span>{{cleaningState[scope.row.state] || '- -'}}</span></template>
      </el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <span class="mr-5" v-if="scope.row.isTurnClue==1 && type !== 3">已转化</span>
          <span v-if="scope.row.isTurnClue!=1&&type !== 3 && (NODE_ENV !== 'erp-prod' && NODE_ENV !== 'erp')" class="receive-btn mr-16" @click="clickOneReceive(scope.row,1)">转线索</span>
          <span v-if="scope.row.isTurnClue!=1&&type !== 3 && (NODE_ENV == 'erp-prod' || NODE_ENV == 'erp')" class="receive-btn mr-16" @click="addCrm(scope.row,1)">转线索</span>
          <em v-if="type === 3">
            <span class="receive-btn mr-30" @click="clickOneReceive(scope.row,4)">恢复</span>
            <span class="receive-btn mr-5" @click="clickOneReceive(scope.row,5)">删除</span>
          </em>
        </template>
      </el-table-column>
    </el-table>
    <!-- 查看号码抽屉 -->
    <!-- <view-number ref="vNumber" :baseData="numberData" :companyStatus="companyStatus" :unlockMark="unlockMark" /> -->
    <ViewNumber ref="vNumber" v-if="drawerShow!==null" :show.sync="drawerShow" :companyStatus="companyStatus" />
    <erp-get-dialog ref="erpGetDialog" @submitCrmFormData="getCrmFormData" :erpGetFlag="erpGetStatusFlag" :erpbackTip="erpGetbackTip"></erp-get-dialog>
  </div>
</template>

<script>
import quan from '@/assets/quan.svg'
import { debounce } from '@/base/global'
import ViewNumber from '@/components/viewNumber'
import { mapState } from 'vuex'
import { star, contactSubmitV2, removeCompanyToTrash, contactOperate, contactReset, contactRevocation, contactCopy, contactLabel, contactRemark } from '../api/index'
import { contactList, searchByName, contactCount, feedback, feedbackDetail, copyContact, testPoint, delTag } from '../api/newClueApi'
import { X_BLOCK, X_PRODUCT, X_HIDE } from '@/utils/iframeUtils'
import ErpGetDialog from '@/components/erpGetDialog'
import lodash from 'lodash'
export default {
  components: {
    ViewNumber,
    ErpGetDialog
  },
  props: {
    type: { // 1 待我跟进列表 2 等会儿再打列表 3 回收站列表
      type: Number,
      default: 1
    },
    propItem: {
      type: Object,
      default: () => { }
    },
    parentSelectAll: {
      type: Boolean,
      default: false
    },
    selectWidth: {
      type: Number,
      default: 46
    },
    contactNameWidthFlag: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      drawerShow: null,
      unlockMark: true,
      quan,
      waiting: false,
      numberData: [],
      companyStatus: {
        companyName: '',
        name: '',
        lockStatus: false,
        contactCount: {},
        companyView: {}
      },
      numberFeedBack: ['正常号码', '空号', '停机', '不在服务区', '拒接', '错号', '关机'],
      checkList: [],
      feedBackWait: false,
      checkAll: false,
      clueSelectAll: [],
      marksTag: ['高意向', '无意向', '等会再打', '打不通', '信息有误'],
      marksTagVal: '', // 添加的备注标签
      marksInput: '', // 输入的备注
      marksRow: '', // 某一行设置了备注
      // tagBgColor:['#edf3ff', '#e6fbf3', '#ffece1', '#fff3f3', '#f5efff']
      tagBgColor: { 高意向: 'tbg1', 无意向: 'tbg4', 等会再打: 'tbg3', 打不通: 'tbg4', 信息有误: 'tbg5' },
      rowDetail: {
        remark: ''
      },
      NODE_ENV: '',
      erpGetStatusFlag: 0,//是否是erp领取 弹出信息
      erpGetbackTip: '',//erp领取返回的接口提示 
      erpFormParam: {},//表单数据
      itemVal: {},//table 单个表单数据
      cleaningState: { 0: '空号', 1: '活跃号', 4: '沉默号', 5: '风险号', 100: '未检测' },  //state  清洗状态 0-空号 1-实号 4-沉默号 5-风险号 100-未检测
      productLineName: '',//产品线
      propItems: {}
    }
  },
  computed: {
    ...mapState({
      staffInfo: state => state.user.staffInfo
    }),
    getPropItems() {
      if (!this.propItems.infoList && !this.propItems.infoList.length) return
      return this.propItems.infoList.forEach(el => {
        this.$set(el, 'createTime', this.propItems.createTime)
        this.$set(el, 'unlockType', this.propItems.unlockType)
        this.$set(el, 'contactInfo', el.content)
      })
    },
    clueSelected() {
      return this.$store.state.user.unlockList
    },
    hasLabel(label) {
      return function (label) {
        return !!label
      }
    },
    lableLine(label) {
      return function (label) {
        return ['无意向', '打不通', '信息有误'].includes(label)
      }
    },
    remark(label) {
      return function (label) {
        if (this.contactNameWidthFlag) {
          return label.length <= 8 ? label : `${label.slice(0, 8)}...`
        } else {
          return label.length <= 19 ? label : `${label.slice(0, 19)}...`
        }

      }
    },
    tagColor(label, tag) {
      return function (label, tag) {
        if (label) return label === tag ? this.tagBgColor[tag] : 'tbg2'
        else return this.tagBgColor[tag]
      }
    }
  },
  watch: {
    propItem: {
      deep: true,
      immediate: true,
      handler: function (val) {
        this.propItems = lodash.cloneDeep(val)
      }
    },
    parentSelectAll(val) {
      this.checkAll = val
      this.changeAll()
    },
    '$store.state.user.unlockList'(val) {
      if (!val.length) {
        this.checkAll = false
      }
    }
  },
  directives: {
    // 注册一个局部的自定义指令 v-focus
    focus: {
      // 指令的定义
      inserted: function (el) {
        // 聚焦元素
        el.querySelector('input').focus()
      }
    }
  },
  mounted() {
    this.NODE_ENV = process.env.NODE_ENV
    this.productsLineNameSource()
  },
  methods: {
    // 产品线
    productsLineNameSource() {
      let productName = ''
      if (window[X_PRODUCT]) {
        productName = windowProductObj[window[X_PRODUCT]]
      } else {
        if (window[X_BLOCK]) {
          productName = 'SCRM企微'
        } else {
          if (window[X_HIDE]) {
            productName = 'SCRM专业'
          } else {
            productName = (process.env.NODE_ENV == 'erp-prod' || process.env.NODE_ENV == 'erp') ? 'ERP-臻寻客' : 'T云-臻寻客'
          }
        }
      }
      this.productLineName = productName
    },
    async closeTag(val) {
      const res = await delTag({ sid: val })
      if (res.code == 200) {
        this.$message.success(res.message)
        this.$emit('unlockList')
      }
    },
    labelFocus($event, row) {
      this.rowDetail = JSON.parse(JSON.stringify(row))
    },
    labelBlur(event, row) {
      row.focusType = false
      if ((!row.remarkInput.trim() && row.isFollow !== 1) || (!row.remarkInput.trim() && !row.remark)) return
      if (row.remarkInput.trim() !== row.remark) this.contactRemark(row)
      row.remark = row.remarkInput.trim()
    },
    async contactRemark(row) {
      await contactRemark({
        avatarUrl: this.propItems.avatarUrl,
        companyName: this.propItems.companyName,
        contacts: [{
          source: JSON.stringify(row.sources),
          contactInfo: row.content,
          contactName: row.contactName,
          type: row.type
        }],
        hid: this.propItems.hid,
        sid: row.sid,
        type: row.type,
        remark: row.remarkInput.trim(),
        productName: this.productLineName
      })
      this.$emit('unlockList')
      // 埋点
      let paramsM = {
        eventType: 'remark_update_event',//事件类型
        productName: this.productLineName,//产品线名称
        type: 1,
        contactInfo: row.content,
        hid: this.propItems.hid
      }
      testPoint(paramsM).then(res => {

      }).catch(err => {

      })
    },
    remarkFocus(row, i) {

      // this.$set(row,'focusType', true)

      this.propItems.infoList[i].focusType = true
      // row.focusType = true
      // this.$nextTick(() => {
      //   this.refs[`remark${row.cid}Input`].
      // })
    },
    // 选择标签
    choiceTag(tag, row) {
      this.contactLabel(row, tag)
    },
    async contactLabel(row, tag) {
      await contactLabel({
        avatarUrl: this.propItems.avatarUrl,
        companyName: this.propItems.companyName,
        contacts: [{
          source: JSON.stringify(row.sources),
          contactInfo: row.content,
          contactName: row.contactName,
          type: row.type
        }],
        hid: this.propItems.hid,
        sid: row.sid,
        type: row.type,
        label: tag
      })
      this.$emit('unlockList')
      // 埋点
      let paramsM = {
        eventType: 'remark_update_event',//事件类型
        productName: this.productLineName,//产品线名称
        type: 1,
        contactInfo: row.content,
        hid: this.propItems.hid
      }
      testPoint(paramsM).then(res => {

      }).catch(err => {

      })
    },
    // cellClsNm ({ row, column, rowIndex, columnIndex }) {
    //   if (columnIndex == 3) {
    //     return 'line-through'
    //   }
    // },
    addClass({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 3) { // 此判断为前两列
        return 'contact-hover'
      }
      if (columnIndex == 4) { // 此判断为前两列
        return 'label-hover'
      }
    },
    // 复制公式ming
    copyName(row) {
      const val = row.content
      var textBox = document.createElement('input')
      textBox.value = val
      document.body.appendChild(textBox)
      textBox.select()
      document.execCommand('Copy')
      textBox.className = 'textBox'
      textBox.style.display = 'none'
      // this.$message.success('复制成功')
      this.$message({
        type: 'success',
        message: '复制成功',
        duration: 2000
        // customClass: 'success-name'
      })
      document.body.removeChild(textBox)
      // 埋点
      copyContact({ companyName: row.companyName, hid: row.hid, contactContent: row.content }).then(res => {
        console.log(res)
      }).catch(error => {
        console.log(error)
      })


      //  let productName = ''
      //   if(window[X_PRODUCT]){
      //     productName = windowProductObj[window[X_PRODUCT]]
      //   }else{
      //       if(window[X_BLOCK]){
      //           productName = 'SCRM企微'
      //       }else{
      //         if(window[X_HIDE]){
      //           productName = 'SCRM专业'
      //         }else{
      //             productName = (process.env.NODE_ENV == 'erp-prod' || process.env.NODE_ENV == 'erp')?'ERP-臻寻客':'T云-臻寻客'
      //         }
      //       }
      //   }
      let paramsM = {
        eventType: 'contact_copy',//事件类型
        productName: this.productLineName,//产品线名称
        pageSource: '解锁列表',
        type: row.type,
        contactRank: 1,
        contactInfo: row.content,
        hid: row.hid
      }
      testPoint(paramsM).then(res => {

      }).catch(err => {

      })

      contactCopy({
        avatarUrl: this.propItems.avatarUrl,
        companyName: this.propItems.companyName,
        contacts: [{
          source: JSON.stringify(row.sources),
          contactInfo: row.content,
          contactName: row.contactName,
          type: row.type
        }],
        hid: this.propItems.hid,
        sid: row.sid,
        type: row.type
      }).then(res => {
        console.log(res)
        this.$emit('unlockList')
      })
    },
    // clickCall (row) {
    //   var data = {
    //     customerNumber: row.content,
    //     contactName: row.contactName
    //   }
    //   this.$bus.$emit('callFixed', data)
    // },
    changeAll() {
      if (this.checkAll) {
        // 去除已领取过的线索
        // this.clueSelectAll = this.propItems.infoList.filter(v => v.isTurnClue !== 1)
        this.clueSelectAll = this.propItems.infoList
        this.clueSelectAll.forEach(v => v.checked = true)
      } else {
        this.clueSelectAll.forEach(v => v.checked = false)
      }
      // 增加成立时间 字段
      this.clueSelectAll.forEach(v => v.estiblishTime = this.propItems.estiblishTime)
      this.$store.commit('SET_UNLOCK_CheckAll', this.checkAll)
      this.$store.commit('SET_UNLOCK_LIST', this.clueSelectAll)
    },
    changeOne(row, es) {
      // 增加成立时间 字段
      row.estiblishTime = es
      let index = this.$store.state.user.unlockList.findIndex(f => f.infoId == row.infoId)
      if (row.checked) {
        if (index == -1) {
          this.$store.state.user.unlockList.push(row)
        }
      } else {
        if (index > -1) {
          this.$store.state.user.unlockList.splice(index, 1)
        }
      }
      var num = 0
      this.propItems.infoList.filter(v => {
        if (v.checked) {
          num++
        }
      })
      this.checkAll = num > 0
      // this.clueSelectAll = [row]
      // if (this.propItems.infoList.filter(item => item.isTurnClue !== 1).every(item => item.checked)) {
      //   this.checkAll = true
      // } else {
      //   this.checkAll = false
      // }
      // this.$store.commit('SET_UNLOCK_CheckOne', row.checked)
      // this.$store.commit('SET_UNLOCK_ONE_LIST', this.clueSelectAll)
    },
    clickChange(item) {
      item.collapse = !item.collapse
    },
    // 收藏
    handleStarB: debounce('handleStar', 300),
    async handleStar() {
      let type // 1标准资源 2智能推荐
      this.propItems.similarValue ? type = 2 : type = 1
      let collect // 1收藏 0 取消
      this.propItems.star ? collect = 0 : collect = 1
      const res = await star({ collect, type, name: this.propItems.companyName, hid: this.propItems.hid, similarValue: this.propItems.similarValue, similarity: this.propItems.similarity })
      if (res.code === 200) {
        if (collect) {
          this.$message.success('收藏成功！')
        } else {
          this.$message.success('取消收藏成功！')
        }
        this.propItems.star = !this.propItems.star
      } else {
        this.$message.success(res.message)
      }
    },
    addCrm(val, sign) {
      this.$refs.erpGetDialog.iniFun(val)
      this.erpGetStatusFlag = 0
      this.itemVal = val
    },
    getCrmFormData(data) {
      this.erpFormParam = data
      this.clickOneReceive(this.itemVal, 1)
    },
    // 单个领取
    clickOneReceive(val, sign) {
      this.$emit('getLoading', true)
      const params = {
        contactInfoList: [{
          companyName: val.companyName,
          hid: val.hid,
          type: val.type,
          contacts: [{
            source: JSON.stringify(val.sources),
            contactInfo: val.content,
            contactName: val.contactName,
            type: val.type,
            isTurnClue: val.isTurnClue,
            ...this.erpFormParam,
          }]
        }]
      }
      if (sign === 1) {
        this.contactSubmitV2(val, params)
      }
      if (sign === 2) {
        params.optType = 1 // 1等会再打
        params.optValue = val.isCallLater === 1 ? 2 : 1
        contactOperate(params).then(res => {
          this.$emit('getLoading', false)
          this.$message.success((val.isCallLater === 1 ? '撤销等会再打' : '等会再打') + '成功')
          this.$emit('unlockList', true)
        })
      }
      if (sign === 3) {
        params.optType = 2 // 2无意向
        params.optValue = val.isIntention === 0 ? 2 : 1
        contactOperate(params).then(res => {
          this.$emit('getLoading', false)
          this.$message.success((val.isIntention === 0 ? '撤销无意向' : '无意向') + '成功')
          this.$emit('unlockList', true)
        })
      }
      if (sign === 4) {
        contactRevocation(params).then(res => {
          this.$emit('getLoading', false)
          this.$message.success('恢复成功')
          this.$emit('unlockList', true)
        }).catch(err => {
          this.$emit('getLoading', false)
        })
      }
      if (sign === 5) {
        contactReset(params).then(res => {
          this.$emit('getLoading', false)
          this.$message.success('删除成功')
          this.$emit('unlockList', true)
        }).catch(err => {
          this.$emit('getLoading', false)
        })
      }
    },
    removeCompanyToTrash() {
      if (this.propItems.infoList && this.propItems.infoList.length) {
        this.propItems.infoList.forEach(e => {
          // e.sources = JSON.stringify(e.sources)
        })
      }
      var params = {
        contactInfoList: [{
          companyName: this.propItems.companyName,
          hid: this.propItems.hid,
          isCompany: 1,
          contacts: this.propItems.infoList.map(e => {
            return {
              sources: JSON.stringify(e.sources),
              contactInfo: e.contactInfo,
              contactName: e.contactName,
              type: e.type,
              // isTurnClue:e.isTurnClue
            }
          })
        }]
      }

      const unconverted = this.propItems.infoList.filter(e => e.isTurnClue == 0 || e.isTurnClue == null).length
      this.$emit('getLoading', true)
      removeCompanyToTrash(params).then(res => {
        this.$emit('getLoading', false)
        this.$message.success(`回收成功${unconverted}条`)
        this.$emit('unlockList', true)
      }).catch(err => {
        this.$emit('getLoading', false)
      })
    },

    // 领取线索
    async contactSubmitV2(val, params) {
      try {
        const { code, message } = await contactSubmitV2(params)
        this.$emit('getLoading', false)
        if (code === 200) {
          this.$message.success('领取成功')
          val.isTurnClue = 1
          this.$emit('unlockList')
          this.erpGetStatusFlag = 1
          this.erpGetbackTip = message
        }
      } catch (err) {
        this.$emit('getLoading', false)
        this.erpGetStatusFlag = 2
        this.erpGetbackTip = err.data.message
        if (process.env.NODE_ENV == 'erp-prod' || process.env.NODE_ENV == 'erp') {
          this.$parent.unlockList()  //解锁列表线索状态
        }
      }
    },

    titleHandle() {
      // 是否是演示账号
      if (this.staffInfo.demonstrationTag == 1) {
        this.$message({
          message: '演示账号，无法使用此功能',
          type: 'error'
        })
        return false
      }
      this.searchByName()
      this.companyStatus = { companyName: this.propItems.companyName, hid: this.propItems.hid, lockStatus: true }
      this.drawerShow = true
    },
    // 查询公司信息
    async searchByName() {
      const { data } = await searchByName({ name: this.propItems.companyName, hid: this.propItems.hid })
      this.companyStatus = { companyName: this.propItems.companyName, lockStatus: true, ...data.items[0] }
      this.companyView = data.items[0]
    },
  }
}
</script>

<style lang="scss" scoped>
.main-box {
  .table-content {
    /deep/ .label-hover {
      .cell {
        overflow: visible;
      }
    }
    .label-content {
      width: 100%;
      display: flex;
      align-items: center;
      position: relative;
      .label {
        // width:64px;
        min-width: 83px;
        flex: 0 0 64px;
        display: flex;
        .tag-content {
          //  width:auto;
        }
      }
      .addIcon {
        background: url("~@/assets/addIcon.svg") no-repeat center;
        background-size: 100%;
        width: 20px;
        height: 20px;
        display: block;
      }
      .el-button {
        padding: 0;
        box-sizing: border-box;
        line-height: normal;
        border: none;
        // position: absolute;
        // top: 0;
        // bottom: 0;
        // left: 0;
        // margin: auto;
        // width:64px;
        .addIcon {
          background: url("~@/assets/addIcon.svg") no-repeat center;
          background-size: 100%;
          width: 20px;
          height: 20px;
          display: block;
        }
      }
      .tag-content {
        // width:64px;
      }
      .mTag {
        display: inline-block;
        height: 24px;
        padding: 4px 8px;
        border-radius: 2px;
        font-size: 12px;
        cursor: pointer;
        white-space: nowrap;
        border: none;
        &.tbg1 {
          background: rgba(48, 191, 120, 0.15);
          color: #30bf78;
          .tficonfont {
            background: #30bf78;
          }
        }
        &.tbg2 {
          background: rgb(243, 243, 245);
          color: #555555;
          .tficonfont {
            background: #555555;
          }
        }
        &.tbg3 {
          background: rgba(80, 136, 255, 0.15);
          color: #5088ff;
          .tficonfont {
            background: #5088ff;
          }
        }
        &.tbg4 {
          background: rgba(244, 102, 74, 0.15);
          color: #f4664a;
        }
        &.tbg5 {
          background: #fff1d9;
          color: #ffa000;
        }
      }
      .remark {
        margin-left: 8px;
        // padding-left:10px;
        font-size: 14px;
        color: #333333;
        white-space: nowrap;
        overflow: hidden;
      }
      .marksInput {
        margin-left: 8px;
        height: 36px;
        /deep/ {
          .el-input__inner {
            border-color: transparent;
            background: transparent;
            width: 132px;
            height: 34px;
            padding-left: 0;
            &:focus,
            &:hover {
              outline: none;
              box-shadow: none;
              border: 1px solid #e8e8f0;
              background: #fff;
            }
            &:focus {
              width: 422px;
              position: absolute;
              left: 0px;
              z-index: 1;
            }
          }
        }
        &:hover {
        }
      }
      .remark {
        cursor: pointer;
      }
    }
  }
  .container-head {
    padding: 15px 24px;
    box-sizing: border-box;
    border-bottom: 1px solid #ddd;
    color: #333333;
    .container-head-left {
      display: flex;
      flex-shrink: 1;
      flex-grow: 1;
      .unlf {
        cursor: pointer;
        margin-right: 9px;
        line-height: 26px;
        font-weight: bold;
      }
      .unlock-time {
        margin-left: 8px;
        font-size: 14px;
        color: #5c6075;
        line-height: 26px;
      }
    }
    .container-head-right {
      cursor: pointer;
      font-size: 13px;
      color: rgba(51, 51, 51, 0.5);
      line-height: 25px;
    }
  }
  .icon-qiye-tianchong {
    color: #4f7afd;
    font-size: 20px;
    margin-right: 5px;
  }
  .tags {
    margin: 0px 8px 0 0;
    height: 24px;
    line-height: 24px;
    padding: 0 13px;
    box-sizing: border-box;
    font-weight: 400;
    color: #30bf78;
    font-size: 12px;
    border-radius: 2px;
    background: rgba(48, 191, 120, 0.15);
  }
}
.bg {
  // background-image: url("~@/assets/industry/star2.png");
  background-image: url("~@/assets/gbIcon/xx.svg");
  background-repeat: no-repeat;
  width: 20px;
  height: 20px;
  background-size: 100%;
  cursor: pointer;
  margin-top: 2px;
}
.unstar {
  // background-image: url("~@/assets/industry/star.png");
  background-image: url("~@/assets/gbIcon/star.svg");
}
.underline {
  text-decoration: underline;
  color: #f59a23 !important;
  // font-size: 12px;
  font-size: 14px;
  cursor: pointer;
}
.receive-btn {
  color: #5088ff;
  font-size: 14px;
  cursor: pointer;
  &.mr-30 {
    margin-right: 16px;
  }
}
.source {
  font-size: 12px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: inline-block;
  width: 100%;
  line-height: 24px;
  > img {
    vertical-align: initial;
    margin-right: 3px;
  }
}
.mr-5 {
  margin-right: 5px;
}
/deep/ .el-table td {
  // padding: 0 10px;
  box-sizing: border-box;
  height: 48px;
  line-height: 48px;
}
/deep/ .el-table th {
  padding: 12px 10px;
}
.height-anima-close {
  height: 0;
  overflow: hidden;
  transition: height 0.5s;
}
.height-anima-open {
  height: auto;
}
.mr-30 {
  margin-right: 30px;
}
.mr-16 {
  margin-right: 16px;
}
.imgIcon {
  margin-right: 5px;
  margin-bottom: 3px;
  width: 20px;
  height: 20px;
}
::v-deep {
  .container-head {
    .container-head-right.recycle {
      color: #5088ff;
      font-weight: 400;
      font-size: 14px;
      .icon-huishouzhan {
        position: relative;
        &::before {
          font-size: 20px;
          position: absolute;
          right: 2px;
          bottom: -5px;
          //  background-image: url("~@/assets/gbIcon/recycle_bin_icon.svg");
          //  width: 20px;
          //  height: 20px;
        }
      }
    }
    .container-head-right.zk {
      i {
        margin-left: 4px;
      }
    }
  }
  .el-table__cell {
    .el-link--inner {
      padding-bottom: 2px;
      color: #5088ff;
    }
    .line-through {
      text-decoration: line-through;
      color: #555555;
    }
    .marks-box {
      > span {
        display: inline-block;
      }
      padding-left: 10px !important;
      position: relative;
      box-sizing: border-box;
      .el-button {
        padding: 0 2px;
        box-sizing: border-box;
        line-height: normal;
        border: none;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        margin: auto;
        .addIcon {
          background: url("~@/assets/addIcon.svg") no-repeat center;
          background-size: 100%;
          width: 20px;
          height: 20px;
          display: block;
        }
      }
      .el-input {
        width: 85px;
        cursor: pointer;
        transition: all 0.3s;
        // margin-left: 8px;
        margin-left: 17px;
        input {
          border: none;
          background: none;
          transition: all 0.3s;
          &:hover {
            border: 1px solid #e8e8f0;
            background-color: #ffffff;
          }
          &:focus {
            // width: 116px;
            width: 422px;
            border-radius: 4px;
            border: 1px solid #e8e8f0;
          }
        }
      }
    }
  }
  .contact-hover {
    .cell {
      > div {
        transform: all 0.5s;
      }
    }
    .copy-icon {
      margin-left: 8px;
      color: #5088ff;
      font-size: 12px;
      cursor: pointer;
      transition: all 0.3s;
      display: none;
    }
    &:hover {
      .copy-icon {
        display: inline;
      }
      .cell {
        > div {
          color: #5088ff;
          // transform: scale(1.1);
        }
      }
    }
  }
  // 删除标签图标颜色
  .mTag {
    .tficonfont {
      margin-left: 4px;
      &::before {
        color: #ffffff;
      }
    }
    &.tbg1 {
      .tficonfont {
        background: #30bf78;
      }
    }
    &.tbg2 {
      .tficonfont {
        background: #555555;
      }
    }
    &.tbg3 {
      .tficonfont {
        background: #5088ff;
      }
    }
    &.tbg4 {
      .tficonfont {
        background: #f4664a;
      }
    }
    &.tbg5 {
      background: #fff1d9;
      color: #ffa000;
      .tficonfont {
        background: #ffa000;
      }
    }
  }
}
.unlock-container {
  .main-box {
    color: red;
    .singleTag {
      padding: 4px 8px;
      box-sizing: border-box;
      border-radius: 2px;
      display: inline-block;
      font-size: 12px;
      &.suspectedContact {
        background: rgba(147, 130, 255, 0.15);
        color: #9382ff;
      }
      &.bookkeepingAgency {
        background: #fff1d9;
        color: #ffa000;
      }
    }
  }
}
.marks-box,
.choiceTag {
  .mTag {
    padding: 4px 8px;
    border-radius: 2px;
    font-size: 12px;
    cursor: pointer;
    &.tbg1 {
      background: rgba(48, 191, 120, 0.15);
      color: #30bf78;
    }
    &.tbg2 {
      // background: #F3F3F5;
      // color: #F3F3F5;
      background: rgba(244, 102, 74, 0.15);
      color: #f4664a;
    }
    &.tbg3 {
      background: rgba(80, 136, 255, 0.15);
      color: #5088ff;
    }
    &.tbg4 {
      background: rgba(244, 102, 74, 0.15);
      color: #f4664a;
    }
    &.tbg5 {
      background: #fff1d9;
      color: #ffa000;
    }
  }
}
</style>
<style lang="scss">
.remark-popper {
  max-width: 306px;
  padding: 16px;
  font-size: 13px;
  color: #666666;
  line-height: 20px;
}
.marksPP {
  width: 148px;
  background: rgba(255, 255, 255, 0.95);
  // box-shadow: 0px 2px 20px 0px rgba(0,0,0,0.15);
  border-radius: 4px;
  padding: 0;
  font-size: 0;
  cursor: pointer;
  box-sizing: border-box;
  border: 0;
  .tag-content-hover {
    display: flex;
    width: 100%;
    padding: 12px;
    flex-wrap: wrap;
    font-size: 0;
    .tag {
      margin-right: 6px;
      height: 24px;
      border-radius: 2px;
      line-height: 24px;
      padding: 0 8px;
      white-space: nowrap;
      margin-bottom: 8px;
      font-size: 12px;
      &:last-child {
        margin-bottom: 0px;
      }
      &:nth-child(even) {
        margin-right: 0;
      }
      &.tbg1 {
        background: rgba(48, 191, 120, 0.15);
        color: #30bf78;
      }
      &.tbg2 {
        background: #f3f3f5;
        color: #555555;
      }
      &.tbg3 {
        background: rgba(80, 136, 255, 0.15);
        color: #5088ff;
      }
      &.tbg4 {
        background: rgba(244, 102, 74, 0.15);
        color: #f4664a;
      }
      &.tbg5 {
        background: #fff1d9;
        color: #ffa000;
      }
    }
  }
}
.el-message--success .el-message__content {
  color: #30bf78;
}
.el-message--success {
  background-color: #f6fff6;
  border-color: #caefdc;
}
.unlock-container {
  .main-box {
    .el-table {
      td {
        text-align: center;
      }
      .el-table__row {
        td {
          // &:nth-of-type(5){
          //   .cell{
          //       color: #5088FF;
          //   }
          // }
          &:nth-of-type(6) {
            position: relative;
          }
          &:nth-of-type(1) {
            text-align: right;
            padding-right: 0;
            padding-left: 0;
          }
          &:nth-of-type(2) {
            padding-right: 20px;
            box-sizing: border-box;
          }
        }
        &:nth-child(odd) {
          background: #fafafd;
          &:hover {
            background: #f0f5ff;
          }
        }
        &:hover {
          background: #f0f5ff;
        }
      }
      .el-table__row td {
        padding: 0 10px;
        box-sizing: border-box;
      }
      th.el-table__cell.is-leaf,
      td.el-table__cell {
        text-align: left;
      }
      th.el-table__cell.is-leaf.is-center,
      td.el-table__cell.is-center {
        // text-align: center;
      }

      th.el-table__cell.is-leaf {
        &:nth-of-type(1) {
          text-align: right;
          .cell {
            padding-left: 0;
            box-sizing: border-box;
          }
        }
      }
      &.el-table--enable-row-hover
        .el-table__body
        tr:hover
        > td.el-table__cell {
        background: none;
      }
    }

    th.el-table__cell .cell {
      font-weight: bold;
    }
    .el-table__cell .cell {
      font-size: 14px;
      color: #333333;
      padding-right: 0;
      span {
        position: relative;
        &.followStatus {
          padding-left: 12px;
          box-sizing: border-box;
          &::before {
            position: absolute;
            display: block;
            content: "";
            width: 6px;
            height: 6px;
            border-radius: 50%;
            left: 0;
            top: 0;
            bottom: 0;
            margin: auto;
          }
          &.noFollow {
            &::before {
              background: #ffa000;
            }
          }
          &.haveFollow {
            &::before {
              background: #30bf78;
            }
          }
        }
      }
    }
    td.el-table__cell div {
      padding-left: 0;
      line-height: normal;
    }
  }
}
.popoverTable {
  max-height: 500px;
  overflow-y: scroll;
}

.contact-tag {
  padding: 12px 12px;
  box-sizing: border-box;
  .twoTag {
    span {
      border-radius: 2px;
      padding: 4px 8px;
      box-sizing: border-box;
      font-size: 12px;
      &:nth-of-type(1) {
        background: #fff1d9;
        color: #ffa000;
        margin-right: 8px;
      }
      &:nth-of-type(2) {
        background: #f3f3f5;
        color: #555555;
      }
    }
  }
}
.el-popper.choiceTag {
  width: 140px !important;
  span {
    background: #f3f3f5;
    color: #555555;
    margin-right: 6px;
    margin-bottom: 8px;
    line-height: 30px;
    cursor: pointer;
    &:nth-of-type(2n) {
      margin-right: 0;
    }
    &:nth-of-type(1) {
      //  margin-right: 5px;
    }
    &:nth-last-of-type(1) {
      margin-bottom: 0;
    }
  }
}
@media screen and (max-width: 1450px) {
  .unlock-container {
    // .el-table_1_column_2{
    //     width: 183px;
    // }
    // .el-table_1_column_3{
    //     width: 78px;
    // }
    // .el-table_1_column_5{
    //     width: 350px !important;
    // }
    // .el-table_1_column_6{
    //     width: 136px;
    // }
    // .el-table_1_column_7{
    //     width: 92px;
    // }
    // .el-table_1_column_8{
    //     width: 88px;
    // }
  }
}
</style>
